import {DataGridPageState, ShiftFilterFormValues, GridSort} from "@ots-frontend/ots-ui";
import {createAction} from "@reduxjs/toolkit";

export const setShiftPageFilter = createAction<ShiftFilterFormValues>("ui/shift-page/setFilter");
export const setShiftPageState = createAction<DataGridPageState>("ui/shift-page/setState");
export const setShiftPageStateCell = createAction<[col: number, row: number]>("ui/shift-page/setStateCell");
export const setShiftPageStateWidths = createAction<(number | undefined)[]>("ui/shift-page/setStateWidths");
export const setShiftPageStateSort = createAction<GridSort | undefined>("ui/shift-page/setStateSort");
